module.exports = __webpack_public_path__ + "static/30-4f9ce35a37233a4436304f9b1a040f12.png";